import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/SiteQueryReportIndex'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Site Query Report Index'}
        >
            <Component 
            />


        </Layout>
    )
}

export default BlockInspectionStatusMasterlist